import React,{lazy, Suspense} from 'react'
import { connect } from 'react-redux';
import { RouteComponentProps } from "react-router"
import {
  IonButton,
  IonContent,
  IonModal,
  IonPage,
  IonIcon,
  withIonLifeCycle,
  isPlatform,
  IonFab,
  IonFabButton,
  IonChip,
  IonLabel,
  IonCol,
  IonRow,
  IonGrid,
  IonActionSheet,
  IonAvatar,
  IonList,
  IonListHeader,
  IonItem,
  IonToolbar,
  IonButtons,
  IonSpinner
} from "@ionic/react"
import { 
  chevronBack,
  person,
  people,
  lockClosed,
  shareSocial,
  create,
  copy,
  addOutline,
  trash,
  ellipsisHorizontal,
  calendarOutline,
  chatboxOutline,
  caretDown,
  mailOutline,
  documentText,
  mic,
  informationCircle,
  close,
  callOutline,
  walk,
  arrowForward
} from 'ionicons/icons'
import { SocialSharing } from "@ionic-native/social-sharing"
import { userState } from '../redux/types/logInTypes';
import { setView, setTeam } from '../redux/actions/logInActions';
import { openAlert } from '../redux/actions/alertActions';
import GoogleMap from "../components/GoogleMap"
import Login from "../components/Login"
import WalkCalendar from "../components/WalkCalendar";
import SmallModalHeader from '../components/SmallModalHeader'
import ErrorPage from './ErrorPage';
import { formatDate, formatEnd } from "../helpers/format_date"
import { BookedPerson, WalkI } from "../interfaces/Walk"
import { openChat, sendMessageWalk } from '../helpers/chat_actions';
import { goBack, goToPage } from '../helpers/app_actions';
// import { enterRoom } from '../helpers/call_helpers';
import { getCurrentWalk } from '../redux/actions/talkAction';
import { PageListenerState } from '../redux/types/pageListenerTypes';
import WebSocketClient from "../services/WebSocketClient"
import Api from "../services/Api"
import FirebaseProvider from '../services/FirebaseAnalytics'
import { Capacitor } from "@capacitor/core";
import { RoomInterface } from '../redux/types/talkRoomTypes';
import history from '../helpers/history';
const Notes = lazy(() => import('../components/Notes'))

interface ComponentProps extends RouteComponentProps<{
    walkId: string
}> {
  user: userState
  setView: Function
  getCurrentWalk: Function
  openAlert: Function
  pageListener: PageListenerState
  walkId?: string
  external?: boolean
  guest?: any
  openNote?: boolean
  talkRoom: any
}

interface ComponentState {
  walk: WalkI
  loaded: boolean
  showBooked: boolean
  showUnBook: boolean
  showCalendar: boolean
  showCancel: boolean
  shareUrl: string
  shareUrlCopied: boolean
  cancelText: string
  addCalendar: boolean
  addedCalendar: boolean
  removeCalendar: boolean
  showRating: boolean
  loggedIn: boolean
  notAllowed: boolean 
  showActionSheet: boolean
  actionSheetButtons: string
  error: Number
  openProfile: boolean
  chosenPerson: {
    firstName: string
    id: number
    picture: string
  },
  showPopover: boolean, 
  bookedPersons: Array<BookedPerson>
  notesOpen: boolean
  openCall: boolean
  infoModal: boolean
}

class Walk extends React.Component<ComponentProps, ComponentState> {
  private firebaseProvider = FirebaseProvider.getInstance()
  private webSocketClient = WebSocketClient.getInstance()
  private api = Api.getInstance()
  private removeCalendarWalk = {} as WalkI
  // resources: ResourcesInterface

  state = {
    loaded: false,
    walk: {} as WalkI,
    showRating: false,
    showBooked: false,
    showUnBook: false,
    showCancel: false,
    shareUrl: '',
    shareUrlCopied: false,
    cancelText: '',
    showCalendar: false,
    addCalendar: false,
    addedCalendar: false,
    removeCalendar: false,
    loggedIn: this.api.loggedIn,
    notAllowed: true,
    showActionSheet: false,
    actionSheetButtons: '',
    error: 0,
    openProfile: false,
    chosenPerson: {
      firstName: '',
      id: 0,
      picture: ''
    },
    showPopover: false, 
    bookedPersons: [],
    notesOpen: false,
    openCall: false,
    infoModal: false
  }

  walkId = this.props.walkId ? this.props.walkId : this.props.match.params.walkId

  myWalk = [{
    text: this.api.tr('edit_walk'),
    icon: create,
    handler: () => {
      this.editWalk()
    }
  }, {
    text: this.api.tr('share_walk'),
    icon: shareSocial,
    handler: () => {
      this.shareWalk()
    }
  }, {
    text: this.api.tr('copy_walk'),
    icon: copy,
    handler: () => {
      this.copyWalk()
    }
  }, {
    text: this.api.tr('add_to_calendar'),
    icon: addOutline,
    handler: () => {
      this.setState({addCalendar: true})
    }
  }, {
    text: this.api.tr('remove_walk'),
    role: 'destructive',
    icon: trash,
    handler: () => {
      this.removeWalk()
    }
  }]

  bookedWalk = [{
    text: this.api.tr('add_to_calendar'),
    icon: addOutline,
    handler: () => {
      this.setState({addCalendar: true})
    }
  }]

  ionViewWillEnter() {
    this.walkId = this.props.walkId ? this.props.walkId : this.props.match.params.walkId

    this.getData()

    if (isPlatform('capacitor')) {
      this.setState({
        showCalendar: true
      })
    }
    if (Capacitor.getPlatform() !== 'web') {
      this.firebaseProvider.trackView('Walk')
    }

    if(history.location.state === 'openCall') {
      // console.log(history, history.location.pathname)
      this.setState({
        notesOpen: true,
        openCall: true
      })
    } else if(history.location.state === 'openNote') {
      this.setState({
        notesOpen: true
      })
    }
  }

  // ionViewDidEnter() {
  //   console.log(this.state)
  // }

  ionViewDidLeave() {
    this.setState({
      loaded: false
    })

    this.props.getCurrentWalk({} as WalkI)
  }

  sendWalkEvent = (number: number) => {
    const data = {
      response_type: number,
      name: this.props.guest.name,
      text: ''
    }
    this.api.post(`walk/event/${this.walkId}`, data).then(res => {
      // console.log(res)
    })
  }

  getWalkEvent = () => {
    // this.
  }

  getSocket = () => {
    this.webSocketClient.sendEvent('message', { 
      type: 'participant_count'
    })
  }

  private getData = () => {
    this.api.get('walk/' + this.walkId).then(res => {
      res.json().then(data => {
        if (data.status === 'ok') {
          if(data.walk.privateWalk && data.walk.availableTo.filter((person: any) => person.id
          )[0].id === this.props.user.person.id){
            this.setState({
              notAllowed: false
            })
            if(data.walk.teamId === null) {
              this.props.setView('public')
              this.setState({
                notAllowed: false
              })
            } else {
              this.props.user.teams.forEach(team => {
                if(team.teamId === data.walk.teamId) {
                  this.props.setView('teams')
                  this.setState({
                    notAllowed: false
                  })
                }
              })
            }
          } else if(data.walk.privateWalk && data.walk.editable === 1){
            this.setState({
              notAllowed: false
            })
          } else if (!data.walk.privateWalk){
            this.setState({
              notAllowed: false
            })
          } else {
            this.setState({
              notAllowed: true
            })
          }

          const walk: WalkI = data.walk
          this.setState({
            walk: walk, 
            loaded: true
          })

          this.props.getCurrentWalk(data.walk)
        } else {
          this.setState({
            notAllowed: true,
            loaded: true
          })
        }
      }).catch(e => {        
        this.setState({
          notAllowed: true,
          loaded: true,
        })
      })
    })
  }

  private logIn = () => {
    this.setState({
      loggedIn: true
    })
    this.getData()
  }

  private closeModal = () => {
    console.log("Can't close modal")
  }

  removeWalk = () => {
    this.api.get('walk/remove/' + this.walkId).then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          this.props.history.goBack()
        } else {
          this.props.openAlert({
            message: this.api.tr('something_went_wrong'),
            header: this.api.tr('error_message')
          })
        }
      }).catch(e => 
        this.props.openAlert({
          message: this.api.tr('something_went_wrong'),
          header: this.api.tr('error_message')
        }))
    }).catch(e => 
      this.props.openAlert({
        message: this.api.tr('something_went_wrong'),
        header: this.api.tr('error_message')
      }))
  }

  private editWalk = () => {
    this.props.history.push('/walk/edit/' + this.walkId)
  }

  bookWalk = () => {
    this.api.get('walk/book/' + this.walkId).then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          const walk = this.state.walk
          walk.booked = 1
          walk.bookedByYou = 1
          this.setState({
            walk: walk, 
            showBooked: true
          })
          const json = `{ "walkId": ${walk.id}, "walkWhen": "${walk.start}", "walkTitle": "${walk.name}" }`
          sendMessageWalk(3, walk.personId, this.api.tr('has_booked_walk'), json)
        } else {
          this.props.openAlert({
            message: this.api.tr('something_went_wrong'),
            header: this.api.tr('error_message')
          })
        }
      }).catch(res => {
        this.props.openAlert({
          message: this.api.tr('something_went_wrong'),
          header: this.api.tr('error_message')
        })
      })
    }).catch(res => {
      this.props.openAlert({
        message: this.api.tr('something_went_wrong'),
        header: this.api.tr('error_message')
      })
    })
  }


  unBookWalk = () => {
    this.removeCalendarWalk = this.state.walk
    this.setState({
      showUnBook: false, 
      removeCalendar: true
    })
    let url = 'walk/unbook/' + this.walkId
    if (this.state.cancelText.length > 0) {
      url += '?message=' + this.state.cancelText
    }
    this.api.get(url).then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          const walk = this.state.walk
          walk.booked = 0
          this.setState({
            walk: walk, 
            cancelText: ''
          })
          const json = `{ "walkId": ${walk.id}, "walkWhen": "${walk.start}", "walkTitle": "${walk.name}" }`
          sendMessageWalk(3, walk.personId, this.api.tr('they_have_cancelled_walk'), json)
        } else {
          this.props.openAlert({
            message: this.api.tr('something_went_wrong'),
            header: this.api.tr('error_message')
          })
        }
      }).catch(e => 
        this.props.openAlert({
          message: this.api.tr('something_went_wrong'),
          header: this.api.tr('error_message')
        }))
    }).catch(e => 
      this.props.openAlert({
        message: this.api.tr('something_went_wrong'),
        header: this.api.tr('error_message')
      }))
  }

  copyWalk = () => {
    this.props.history.push({
      pathname: '/walk/copy',
      state: this.state.walk
    })
  }
 
  private closeBookings = () => {
    this.setState({
      showBooked: false
    })
  }

  private handleCancel = (event: any) => {
    this.setState({
      cancelText: event.target.value
    })
  }

  private cancelWalk = () => {
    const data = {
      cancel_text: this.state.cancelText
    }
    this.api.post('walk/cancel/' + this.walkId, data).then(result => {
      result.json().then(resultJson => {
        if (resultJson.status === 'ok') {
          this.setState({
            showCancel: false
          })
          this.getData()
          if(this.state.walk.bookedPerson) {
            const json = `{ "walkId": ${this.state.walk.bookedPerson.id}, "walkWhen": "${this.state.walk.start}", "walkTitle": "${this.state.walk.name}" }`
            sendMessageWalk(3, this.state.walk.bookedPerson.id, this.api.tr('you_have_cancelled_walk'), json)
          }
        } else {
          this.props.openAlert({
            message: this.api.tr('something_went_wrong'),
            header: this.api.tr('error_message')
          })
        }
      }).catch(e => 
        this.props.openAlert({
          message: this.api.tr('something_went_wrong'),
          header: this.api.tr('error_message')
        }))
    }).catch(e => 
      this.props.openAlert({
        message: this.api.tr('something_went_wrong'),
        header: this.api.tr('error_message')
      }))
  }

  private closeRating = (reload: boolean) => {
    if (reload) {
      this.getData()
    }
    this.setState({showRating: false})
  }

  private showBookings = () => {
    this.setState({showBooked: false})
    this.props.history.push('/walk/mywalks/booked')
  }

  private showRating = () => {
    this.setState({showRating: true})
  }

  private copyToClipboard = (str: string) => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    navigator.clipboard.writeText(el.value).then(() => {
      this.setState({
        ...this.state,
        shareUrlCopied: true
      })
    });
    document.body.removeChild(el);
  }

  private shareWalk = () => {
    const shareUrl = this.state.walk.inviteOnly ? 'https://app.walkingtalking.com/walk/share/privatewalk/' + this.walkId : 'https://app.walkingtalking.com/walk/sharewalk/' + this.walkId
    if (isPlatform('capacitor')) {
      const message = this.api.profile.firstName + this.api.tr('has_shared_walk_message')
      SocialSharing.share(message, 'Walking Talking', '', shareUrl)
    } else {
      this.setState({
        ...this.state,
        shareUrl: shareUrl
      })
    }
  }

  exitCal = (action: string) => {
    if (action === 'delete') {
      this.setState({
        removeCalendar: false
      })
    } else if (action === 'add') {
      this.setState({
        addCalendar: false, 
        addedCalendar: true
      })
    } else {
      this.setState({
        addCalendar: false
      })
    }
  }

  closeProfile = () => {
    this.setState({openProfile: false})
  }

  closeNotesModal = () => {
    window.history.replaceState({}, '', history.location.pathname)
    this.setState({
      notesOpen: false,
      openCall: false
    })
  }

  goBackWalk = () => {
    if(this.props.pageListener.previousLocation.includes('/walk/create')) {
      goToPage('/walk/home')
    } else {
      goBack()
    }
  }

  informationModal() {
    return <IonModal isOpen={this.state.infoModal} class="modal_centered" onDidDismiss={() => this.setState({infoModal: false})}>
      <IonToolbar class="p-2">
        <h2>{this.api.tr('audio_walk')}</h2>
        <IonButtons slot="end" >
          <IonButton onClick={() => this.setState({infoModal: false})}>
            <IonIcon icon={close} size="large" color="dark"/>
          </IonButton>
        </IonButtons>
      </IonToolbar>
      <IonGrid>
        <IonRow class="inoArea fullWidth flex justify-center p-2 m-2">
          <IonIcon icon={callOutline} size="large" color="primary"/>
        </IonRow>
        <IonRow className="p-4">
          <p>
            {this.api.tr('audiowalk_info')}
          </p>
        </IonRow>
      </IonGrid>
    </IonModal>
  }

  render() {
    let button = null
    if (this.state.walk.walkType === 'done') {
      if (this.state.walk.badges) {
        if (this.state.walk.myRatings === 0) {
          button = 
          <IonButton 
            fill="outline"
            className="mt-8" 
            expand="block"  
            onClick={() => this.setState({
              addCalendar: true
            })}>
              {this.api.tr('add_to_calendar')}
          </IonButton>
        }
      }
    } else {
      if (this.state.walk.editable) {
        if (this.state.walk.bookings) {
          button = <div className="mt-8">
           {
             this.state.walk.maxBookings > 1 ?
              <IonChip 
                onClick={() => this.setState({ showPopover: true, bookedPersons: this.state.bookedPersons})}
                class="p-2">
               {this.state.walk.bookings} av {this.state.walk.maxBookings} platser bokade
                <IonIcon icon={caretDown}/>
                <IonModal
                  class="sheetModal"
                  breakpoints={[0.1, 0.5, 1]}
                  initialBreakpoint={0.5}
                  className='my-custom-class'
                  isOpen={this.state.showPopover}
                  onDidDismiss={() => {
                    this.setState({ 
                      showPopover: false, 
                      bookedPersons: [] 
                      })}
                  }>
                  <IonList class="mb-2">
                    <IonListHeader class="p-2">
                      Gäster
                    </IonListHeader>
                    { this.state.walk.bookedPersons && this.state.walk.bookedPersons.map((person: any, key: number) => (
                      <IonItem key={person.id + key} onClick={() => {
                        goToPage('/walk/chat/' + person.id)
                      }}>
                        <IonAvatar slot="start">
                          <img src={person.personPicture} alt=""/>
                        </IonAvatar>
                        <IonLabel class="ml-2">
                          {person.firstName}
                        </IonLabel>
                        <IonIcon icon={mailOutline}/>
                      </IonItem>
                    ))}
                  </IonList>
                </IonModal>
              </IonChip>
             : 
             <>
           {this.state.walk.bookedPerson && 
           <IonGrid>
             <IonRow className="flex p-2 items-center">
              <IonCol size="3">
                <IonAvatar>
                    <img src={this.state.walk.bookedPerson.personPicture} alt="" />
                </IonAvatar> 
              </IonCol>
                <IonLabel>
                  {this.state.walk.bookedPerson?.firstName} {this.api.tr('person_has_booked_walk')}
                </IonLabel>
              </IonRow>
            </IonGrid>
              }
             </>
           }

            <IonButton 
              className="mt-4" 
              expand="block"  
              onClick={() => this.setState({
                showCancel: true
                })}>
              {this.api.tr('you_cancel_button')}
            </IonButton>
          </div>
        } else {
          button = 
          <IonButton 
            className="mt-8" 
            expand="block"  
            onClick={() => this.editWalk()}>
              {this.api.tr('change_walk_button')}
          </IonButton>
        }

      } else {
        if (this.state.walk.booked) {
          if (this.state.walk.bookedByYou === 1) {
            button = 
            <IonButton 
              className="mt-8" 
              expand="block"  
              onClick={() => this.setState({
                showUnBook: true
                })}>
              {this.api.tr('other_cancel_button')}
            </IonButton>
          } else {
            button = <p className="mt-8">{this.api.tr('walk_already_booked')}</p>
          }
        } else {
          button = 
          <IonButton 
            className="mt-8" 
            expand="block"  
            onClick={() => this.bookWalk()}>
              {this.api.tr('book_walk_button')}
          </IonButton>
        }
      }
    }
    return (
    
      <IonPage className="cheap_desktop theWalkPage">
      { this.state.notAllowed && this.state.loaded ? 
        <ErrorPage/>
        : 
          <IonContent fullscreen>
            {/* <CurrentWalk/> */}
            <div className=" walkPage cheap_desktop pos-relative" style={{'overflow': 'scroll', 'height': '100vh'}}>
              <IonModal 
                isOpen={this.state.shareUrl.length > 0} 
                className='modal_small'
                onDidDismiss={() => this.setState({
                  shareUrl: ''
                  })}>
                <div className="mx-4 text_center flex flex-col justify-around pos-relative">
                  <SmallModalHeader
                    pageTitle={this.api.tr('share_walk')}
                    closeModal={() => this.setState({
                      shareUrl: '', 
                      shareUrlCopied: false})}/>
                  <p className="mt-4">{this.api.tr('send_link')}</p>
                  <div className="mt-4 infoArea">
                    <a 
                      target="_new" 
                      href={this.state.shareUrl} 
                      className="text_link">{ !this.state.shareUrlCopied ? this.state.shareUrl : this.api.tr('link_is_copied')}</a>
                  </div>
                  <IonButton 
                    onClick={() => {
                      this.copyToClipboard(this.state.shareUrl)
                    }}
                    class="smallButton" 
                    size="small" 
                    fill="outline">
                    {this.api.tr('copy_link')}
                  </IonButton>
                </div>
              </IonModal>
            <IonModal 
              isOpen={this.state.showUnBook} 
              className='modal_centered' 
              backdropDismiss={false}>
              <div className="mx-4 text_center flex flex-col justify-around">
                <SmallModalHeader 
                  pageTitle={this.api.tr('cancel_walk')}
                  closeModal={() => this.setState({
                    showUnBook: false
                    })}/>
                {/* <section className="infoArea">
                  <IonIcon icon={informationCircle} color="primary" size="large"/>
                  <p>Tänk på att när du avbokar promenaden kan du inte längre chatta med {this.state.walk.personName}.</p>
                </section>
                <h2 className="mt-4">Skicka ett meddelande till {this.state.walk.personName}:</h2>
                <IonTextarea 
                  name="cancel" 
                  value={this.state.cancelText}
                  onIonChange={this.handleCancel}
                  rows={4}
                  placeholder={"Meddelande till " + this.state.walk.personName}
                  className="textarea_default text_left border_gray mt-4"/> */}
                <section className="infoArea">
                  <p>{this.api.tr('no_longer_able_question')}</p>
                </section>
                <IonButton 
                  className="mt-8" 
                  expand="block" 
                  onClick={() => this.unBookWalk()}>
                    {this.api.tr('cancel_walk_confirmation')}
                </IonButton>

                {/* <div className="my-4 text_center color_green" onClick={() => this.setState({showUnBook: false})}>
                  Stäng
                </div> */}
              </div>
            </IonModal>
            <IonModal 
              isOpen={this.state.showCancel} 
              className='modal_centered' 
              backdropDismiss={false}>
              <div className="mx-4 text_center flex flex-col justify-around">
                <SmallModalHeader 
                  pageTitle={this.api.tr('you_cancel_button')}
                  closeModal={() => {
                    this.setState({
                      showCancel: false
                    })}}/>
                {/* <p className="mt-4">Skicka ett meddelande till {this.state.walk.bookedPerson?.firstName}:</p>
                <IonTextarea 
                  name="cancel" 
                  value={this.state.cancelText}
                  onIonChange={this.handleCancel}
                  rows={4}
                  placeholder={"Meddelande till " + this.state.walk.bookedPerson?.firstName}
                  className="textarea_default text_left border_gray mt-4"/>
                <IonButton className="mt-8" expand="block" onClick={() => this.cancelWalk()}>
                  Skicka och avboka
                </IonButton> */}
                <section className="infoArea">
                  <p>{this.api.tr('no_longer_able_question')}</p>
                </section>
                <IonButton className="mt-8" expand="block" onClick={() => this.cancelWalk()}>
                  {this.api.tr('you_cancel_button')}
                </IonButton>

                <div 
                  className="my-4 text_center color_green" 
                  onClick={() => this.setState({
                    showCancel: false
                    })}>
                  {this.api.tr('close')}
                </div>
              </div>
            </IonModal>
            <IonModal 
              isOpen={this.state.addCalendar} 
              onDidDismiss={() => this.setState({
                addCalendar: false
                })}>
              <WalkCalendar 
                exitCal={this.exitCal} 
                walk={this.state.walk} 
                action="add"/>
            </IonModal>
            <IonModal 
              isOpen={this.state.showBooked} 
              className='modal_centered' 
              backdropDismiss={false}>
                
              {/* <div className="mx-4 text_center flex flex-col justify-around"> */}
                <SmallModalHeader 
                  pageTitle={this.api.tr('walk_is_booked')}
                  closeModal={() => this.closeBookings()}/>
                  <div className="text_center mx-4 flex flex-col justify-around">
                <img className="m-12 modalImg" alt="done" src="assets/icon/checkmark_large.svg"/>
                <h1 className="mt-2">{this.api.tr('done')}</h1>
                {/* <p className="my-2">Nu är promenaden bokad. Du kan chatta med {this.state.walk.personName} under Mina promenader. Eller testa den nya chatten</p> */}
                <p>{this.api.tr('the_walk_is_booked')}</p>
                <IonRow class="p-2 fullWidth flex flex-col">
                <IonButton 
                  expand="block" 
                  className="mt-2 flex items-center fullWidth"
                  onClick={() => {
                    this.setState({
                      showBooked: false
                    })
                    openChat(this.state.walk.personId)}
                    }>
                    <IonIcon 
                      class="mr-2"
                      icon={chatboxOutline}/>
                  {this.api.tr('chat_with')} {this.state.walk.personName}
                </IonButton>
                { !this.state.addedCalendar ? 
                <IonButton 
                  fill="outline"
                  className="my-4 flex items-center fullWidth" 
                  onClick={() => this.setState({
                    addCalendar: true
                  })}>
                  <IonIcon 
                    class="mr-2"
                    icon={calendarOutline}/>
                  {this.api.tr('add_to_calendar')}
                </IonButton>
                :
                <h3>{this.api.tr('added_to_cal')}</h3>
                }
                </IonRow>
              </div>
            </IonModal>
            <IonActionSheet
              isOpen={this.state.showActionSheet}
              onDidDismiss={() => this.setState({showActionSheet: false})}
              cssClass='my-custom-class'
              buttons={this.state.actionSheetButtons === 'myWalk' ? this.myWalk : this.bookedWalk }/>

            {
              this.state.loggedIn || this.props.external ? (
                <>
                { this.props.external ? null : 
                  <IonFab 
                    vertical="top" 
                    horizontal="start" 
                    slot="fixed"
                    class="safe_padding_top">
                    <IonFabButton 
                      color="light" 
                      size="small" 
                      onClick={() => {
                        // goBack()
                        this.goBackWalk()
                      }}>
                      <IonIcon icon={chevronBack} size="small"/>
                    </IonFabButton>
                  </IonFab> }
                  { this.state.walk.hasTalk ? 
                  <IonFab 
                    vertical="top" 
                    horizontal="end" 
                    slot="fixed"
                    class="safe_padding_top">
                    <IonFabButton 
                      color="light" 
                      size="small" 
                      onClick={() => this.setState({infoModal: true})}>
                        <IonIcon icon={informationCircle} size="large" color="medium"/>
                    </IonFabButton>
                  </IonFab> : null }
                { this.state.walk.hasCoordinates ? 
                  <div style={{height: "40vh", position: "relative"}}>
                    {
                      this.state.loaded &&
                      <GoogleMap 
                        lat={this.state.walk.lat} 
                        lng={this.state.walk.lng} 
                        zoom={this.state.walk.zoom}
                        placeName={this.state.walk.placeName} 
                        fixedMarker={false} 
                        height={50}/>
                    }
                    <section 
                      style={{'position': 'absolute', 'bottom': '0', 'left': '0'}}
                      className="fullWidth flex justify-between p-2 items-center">
                      {
                      this.state.walk.address !== '' ? 
                        <IonChip class="chip">
                          <IonLabel>{this.state.walk.address}</IonLabel>
                        </IonChip>
                      : null
                      }
                
                    </section>
                  </div>
                  :
                  <section className="walk__audio">
                    <IonGrid className="walk__audio--header flex flex-col justify-end p-2"> 
                    { this.state.walk.hasTalk ? <>
                      { this.state.walk.booked === 1 || this.props.external || this.state.walk.editable || this.state.walk.bookedByYou ?
                        <IonRow class="flex justify-center fullWidth">
                          <IonIcon icon={person} size="small" color="darkblue"/>
                          { this.props.talkRoom.map((room: RoomInterface) => room.room.toString() === this.state.walk.randomKey ? room.participant_count : 0)}
                          <IonButton 
                            color="darkblue" 
                            expand="block"
                            class="fullWidth height_auto my-4"
                            onClick={() => {
                              this.setState({
                                notesOpen: true,
                                openCall: true
                              })
                              // enterRoomState(this.state.walk.personName, this.state.walk.randomKey, this.state.walk.id)
                            }}>
                              <IonGrid class="flex flex-col justify-center items-center p-2 ">
                                <IonRow class="p-2">
                                  {this.api.tr('enter_room')}
                                  <IonIcon icon={mic} class="ml-1"/>
                                  <IonIcon icon={arrowForward} class="ml-1"/>
                                </IonRow>
                              </IonGrid>                            
                          </IonButton> 
                          </IonRow> : 
                          <IonRow>
                            <h2>{this.api.tr('audio_walk')}</h2>
                          </IonRow>
                          } </> : null }

                    
                        <IonFab 
                          vertical="top" 
                          horizontal="end" 
                          slot="fixed"
                          class="safe_padding_top">
                          <IonFabButton color="light" class="ml-2" onClick={() => this.setState({infoModal: true})}>
                            <IonIcon icon={informationCircle} size="large" color="medium"/>
                          </IonFabButton>
                        </IonFab>
                    </IonGrid>
                  </section>
                  }

                  <div 
                    style={{position: "relative", backgroundColor: "#fff"}} 
                    className="walk_card px-4 safe_margin_footer">
                      <IonGrid class="pt-4">
                        { this.state.walk.hasTalk && this.state.walk.hasCoordinates ? 
                        <IonRow class=" flex justify-center fullWidth">
                          <IonRow class="p-2 flex justify-center items-center">
                            </IonRow>
                          { this.state.walk.booked === 1 || this.props.external || this.state.walk.editable || this.state.walk.bookedByYou ?
                          <IonButton 
                            color="darkblue" 
                            expand="block"
                            class="fullWidth height_auto my-4"
                            onClick={() => {
                              this.setState({
                                notesOpen: true,
                                openCall: true
                              })
                              // enterRoomState(this.state.walk.personName, this.state.walk.randomKey, this.state.walk.id)
                            }}>
                              <IonGrid class="flex flex-col justify-center items-center p-2 ">
                                <IonRow class="p-2 flex items-center">
                                  <article className="p-2 m-2">
                                    <IonIcon icon={person} size="small" color="light"/>
                                    { this.props.talkRoom.map((room: RoomInterface) => room.room.toString() === this.state.walk.randomKey ? room.participant_count : 0)}
                                  </article>
                                  {this.api.tr('enter_room')}
                                  <IonIcon icon={mic} class="ml-1"/>
                                  <IonIcon icon={arrowForward} class="ml-1"/>
                                </IonRow>
                              </IonGrid>                            
                          </IonButton> : null}
                        </IonRow>
                        : null}
                        <IonRow>
                          <IonToolbar>
                          { this.state.walk.editable || this.state.walk.bookedByYou || this.state.walk.inviteOnly ? 
                            <IonButton 
                              color="darkblue"
                              onClick={() => {
                                this.setState({
                                  notesOpen: true,
                                  openCall: false
                                })
                              }}>
                              <IonIcon icon={documentText} />
                            </IonButton>
                            : null }
                            <IonButton 
                              color="darkblue"
                              class="mr-2" slot="end" onClick={() => this.shareWalk()}>
                              <IonIcon icon={shareSocial} />
                            </IonButton>
                            {
                            this.state.walk.editable ?
                              <IonButton 
                              color="darkblue"
                                slot="end"
                                onClick={() => this.setState({
                                showActionSheet: true,
                                actionSheetButtons: 'myWalk'
                              })}>
                                <IonIcon 
                                  icon={ellipsisHorizontal} 
                                  size="large"/>
                              </IonButton>
                            : 
                            <>
                            { this.state.walk.bookedByYou ?
                              <IonButton 
                                color="darkblue"
                                slot="end"
                                onClick={() => this.setState({
                                  showActionSheet: true,
                                  actionSheetButtons: 'bookedWalk'
                                })}>
                                  <IonIcon 
                                    icon={ellipsisHorizontal} 
                                    size="large" />
                              </IonButton>
                              :
                              null
                            }
                            </>
                          }
                          </IonToolbar>
                        </IonRow>
                      </IonGrid>
                    <IonRow class="flex flex-col  my-4">
                      <IonRow class="flex items-center">
                        { this.state.walk.hasTalk && this.state.walk.hasCoordinates ? 
                          <IonChip color="darkblue" className="p-2 mr-2 background_smoke flex justify-center items-center">
                            <IonIcon icon={mic}  color="medium"/>
                            / 
                            <IonIcon icon={walk}  color="medium"/>
                          </IonChip>
                          : 
                          <article color="darkblue" className="p-2 mr-2 circle_medium background_smoke flex justify-center items-center">
                            { this.state.walk.hasTalk ?
                            <IonIcon icon={mic} size="large" color="medium"/> :
                            <IonIcon icon={walk} size="large" color="medium"/>
                              }
                          </article>
                        }
                        <h1>{this.state.walk.name}</h1>
                      </IonRow>

                      <p className="gray_medium">{formatDate(this.state.walk.start)}-{formatEnd(this.state.walk.start, this.state.walk.lengthMinutes)}</p>
                    </IonRow>
                    <IonGrid class="mt-2">
                      <IonRow class="flex">
                    { this.state.walk.privateWalk ? 
                      <IonChip color="darkblue" class="p-2">
                        <IonIcon icon={lockClosed}></IonIcon>
                        <IonLabel>
                        {this.api.tr('invitation')}
                        </IonLabel>
                      </IonChip> 
                        : 
                        <>{ this.state.walk.teamId !== null ? 
                          <section>
                            <IonChip color="darkblue" class="p-2">
                              <IonIcon icon={people}/>
                              <IonLabel>{
                                this.props.user.teams.filter(team => team.teamId === this.state.walk.teamId)
                                  .map(team => {
                                    return team.teamName
                                  })
                              }</IonLabel>
                            </IonChip>
                          </section>
                        : 
                          null
                        }</>
                        }
                        { this.state.walk.maxBookings > 1 ? 
                          <IonChip color="darkblue" class="p-2 mr-2">
                            <IonLabel>{this.state.walk.category}
                            { this.state.walk.maxBookings > 1 ? 
                            <>
                              { this.state.walk.bookings === 0 ? 
                                <>
                                  {this.state.walk.bookings} / {this.state.walk.maxBookings} 
                                </>
                                :
                                <>
                                  {this.state.walk.bookings}  / {this.state.walk.maxBookings} 
                                </>
                              }
                            </>
                            : null }
                            </IonLabel>
                          </IonChip>
                          : null
                        }
                        {
                          this.state.walk.inviteOnly ? 
                          <IonChip color="darkblue" class="p-2">
                            <IonLabel>{this.api.tr('private')}</IonLabel>
                          </IonChip> 
                        : null
                        }
                      </IonRow>
                    </IonGrid>
                    { this.state.walk.availableTo !== undefined && this.state.walk.availableTo.length > 0 ? 
                      <IonGrid>
                        <IonRow>
                          <IonCol class="my-3 flex gray_medium">
                            <IonLabel>{this.api.tr('invited_persons')}</IonLabel>
                            {this.state.walk.availableTo.map(person => <p key={person.id}>{person.name} </p>)}
                          </IonCol>
                        </IonRow>
                      </IonGrid>
                     : null }

                    { this.props.external ? 
                    // <IonGrid class="p-4 infoArea">
                    //   <IonRow>
                    //     <IonCol size="6" class="p-2">
                    //       <IonButton 
                    //         onClick={() => {
                    //           this.sendWalkEvent(1)
                    //         }}
                    //         expand="block" 
                    //         color="primary">Acceptera</IonButton>
                    //     </IonCol>
                    //     <IonCol size="6" class="p-2">
                    //       <IonButton 
                    //         onClick={() => {
                    //           this.sendWalkEvent(2)
                    //         }} 
                    //         expand="block" 
                    //         color="darkblue" fill="outline">Tacka nej</IonButton>
                    //     </IonCol>
                    //   </IonRow>
                    // </IonGrid> 
                    null
                    :
                    <>{ button }</>}

                    <div 
                      onClick={() => {this.setState({
                        chosenPerson: {
                          firstName: this.state.walk.personName,
                          id: this.state.walk.personId,
                          picture: this.state.walk.personPicture
                        },
                        // openProfile: true
                      })
                      goToPage('/walk/user/profile/' + this.state.walk.personId)
                    }
                    }
                      className="mt-8 flex items-center justify-between">
                      <div style={{width: "40px"}}>
                        <img className="circle_picture" alt="profil" src={this.state.walk.personPicture}/>
                      </div>
                      <div className="mx-2 flex-1">
                        <p>{this.state.walk.personName}</p>
                      </div>
                      <div 
                        onClick={() => {
                          if(this.state.walk.bookedPerson) {
                            this.setState({
                              chosenPerson: {
                                firstName: this.state.walk.bookedPerson.firstName,
                                id: this.state.walk.bookedPerson.id,
                                picture: this.state.walk.bookedPerson.personPicture
                              },
                              // openProfile: true
                            })
                            goToPage('/walk/user/profile/' + this.state.walk.bookedPerson.id)
                          }
                          }}
                        style={{minWidth: "40px"}}>
                        {
                          this.state.walk.bookedPerson && this.state.walk.maxBookings === this.state.walk.bookings &&
                          <div>
                            <img 
                              className="circle_picture" 
                              alt="{walk.bookedPerson.personName}"
                              src={this.state.walk.bookedPerson.personPicture}/>
                          </div>
                        }
                      </div>
                    </div>
                    <p className="py-4 gray_medium">
                      {this.state.walk.description}
                    </p>
                  </div>
                </>
              ) : (
                  <Login closeModal={this.closeModal}/>
              )
            }
            </div>
            <div className="mt-24"/>
          </IonContent>
          }
        { this.informationModal() }
        <Suspense fallback={<IonSpinner/>}>
          <Notes 
            isOpen={this.state.notesOpen}
            walkId={parseInt(this.walkId)}
            closeModal={this.closeNotesModal}
            walk={this.state.walk}
            openCall={this.state.openCall}
            hasTalk={true}
            guest={this.props.guest ? this.props.guest : {name: '', isSet: false}}/>
        </Suspense>
      </IonPage>
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.logIn.user,
    pageListener: state.pageListener,
    talkRoom: state.talkRoom.walks
  }
}

const mapDispatchToProps = {
  setView,
  setTeam,
  getCurrentWalk,
  openAlert
}

export default connect(mapStateToProps, mapDispatchToProps)(withIonLifeCycle(Walk));
